import {isKuhniVersoMebelDomain} from "./isKuhniVersoMebelDomain";

export const HOME_BREADCRUMB = {name: "Главная", href: "/"};

const getMyOrdersSectionLabel = () =>
    isKuhniVersoMebelDomain() ? "Заказы на распил" : "Мои заказы";

const getMySamplesSectionLabel = () =>
    isKuhniVersoMebelDomain() ? "Шаблоны деталей" : "Мои шаблоны";

export const getCustomerMyOrdersSectionBreadcrumb = () => ({
    name: getMyOrdersSectionLabel(),
    href: "/customer/orders",
});

export const getCustomerMySamplesSectionBreadcrumb = () => ({
    name: getMySamplesSectionLabel(),
    href: "/customer/samples",
});

export const CUSTOMER_ORDERS_SUBMENU_BREADCRUMB = {name: "Заказы", href: "/customer/orders"};
export const CUSTOMER_KITCHEN_ORDERS_SECTION_BREADCRUMB = {
    name: "Мои заказы",
    href: "/customer/kitchen-orders",
};
export const CUSTOMER_KITCHEN_ORDERS_SUBMENU_BREADCRUMB = {
    name: "Заказы",
    href: "/customer/kitchen-orders",
};
export const CUSTOMER_ARCHIVE_SUBMENU_BREADCRUMB = {name: "Архив", href: "/customer/archive"};
export const CUSTOMER_SAMPLES_SUBMENU_BREADCRUMB = {name: "Шаблоны", href: "/customer/samples"};
export const CUSTOMER_GROUPS_SUBMENU_BREADCRUMB = {name: "Группы", href: "/customer/groups"};
export const CUSTOMER_EDGES_SUBMENU_BREADCRUMB = {name: "Кромки", href: "/customer/samples/edges"};
export const CUSTOMER_SYSTEM_SAMPLES_BREADCRUMB = {
    name: "Шаблоны системы",
    href: "/customer/system-samples",
};

export const buildMyOrdersSectionPath = (...segments) => [
    HOME_BREADCRUMB,
    getCustomerMyOrdersSectionBreadcrumb(),
    ...segments,
];

export const buildKitchenOrdersSectionPath = (...segments) => [
    HOME_BREADCRUMB,
    CUSTOMER_KITCHEN_ORDERS_SECTION_BREADCRUMB,
    ...segments,
];

export const buildMySamplesSectionPath = (...segments) => [
    HOME_BREADCRUMB,
    getCustomerMySamplesSectionBreadcrumb(),
    ...segments,
];

export const buildSystemSamplesPath = (...segments) => [
    HOME_BREADCRUMB,
    CUSTOMER_SYSTEM_SAMPLES_BREADCRUMB,
    ...segments,
];
